<template>
    <div id="app">
        <!--        <div class="top-context">-->
        <!-- Header Area wrapper Starts -->
        <!-- Navbar Start -->
        <Navbar/>
        <!-- Navbar End -->
        <!-- Header Area wrapper End -->
        <!--        </div>-->

        <!--        <div class="content-center full-height scrollable">-->
        <router-view/>
        <!--        </div>-->


        <!--        <div class="bottom-context">-->
        <!-- Footer Section Start -->
        <Footer/>
        <!-- Footer Section End -->
        <!--        </div>-->


        <!-- Go to Top Link -->
        <a href="#" class="back-to-top">
            <i class="lni-arrow-up"></i>
        </a>

        <!-- Preloader   -->
        <div id="preloader">
            <div class="loader" id="loader-1"></div>
        </div>
        <!-- End Preloader -->
        <!--    ok-title="Accept"-->
        <b-modal id="modal-about-us-1"
                 centered
                 scrollable
                 ok-only>
            <template v-slot:modal-title>
                {{$t('aboutUs.txt1')}}
            </template>
            <div class="d-block content">
                <div class="icon">
                    <img class="img-fluid" src="./assets/img/about/person-centered.svg" alt="">
                </div>
                <div class="about-us-content">
                    <p> {{$t('aboutUs.modal1.txt1')}}</p>
                    <p> {{$t('aboutUs.modal1.txt2')}}</p>
                    <p> {{$t('aboutUs.modal1.txt3')}}</p>
                    <p> {{$t('aboutUs.modal1.txt4')}}</p>
                    <p> {{$t('aboutUs.modal1.txt5')}}</p>
                    <p> {{$t('aboutUs.modal1.txt6')}}</p>
                    <ul>
                        <li> {{$t('aboutUs.modal1.list.li1')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li2')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li3')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li4')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li5')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li6')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li7')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li8')}}</li>
                        <li> {{$t('aboutUs.modal1.list.li9')}}</li>
                    </ul>


                </div>
            </div>


        </b-modal>

        <!--    CLIENT’S RIGHTS STATEMENT-->
        <b-modal id="modal-statement"
                 centered
                 scrollable
                 ok-only>
            <template v-slot:modal-title>
                {{$t('clients.statement.title')}}
            </template>
            <div class="d-block content">
                <div class="icon">
                    <img class="img-fluid" src="./assets/img/clients/umbrella-client.svg" alt="">
                </div>
                <div class="clients-content">
                    <ul>
                        <li v-for="index in 20" :key="index" v-html="$t('clients.statement.txt' + index)"></li>
                    </ul>

                </div>
            </div>


        </b-modal>

        <!--    NOTICE OF PRIVACY PRACTICES -->
        <b-modal id="modal-notice-privacy"
                 centered
                 scrollable
                 ok-only>
            <template v-slot:modal-title>
                {{$t('clients.privacy_practices.title')}}
            </template>
            <div class="d-block content">
                <div class="icon">
                    <img class="img-fluid" src="./assets/img/clients/legal.svg" alt="">
                </div>
                <div class="clients-content">
                    <!--          PART #1-->
                    <div class="row">
                        <p v-for="index in 7" :key="'phitxt'+index"
                           v-html="$t('clients.privacy_practices.phi.txt' + index)"></p>
                        <ul>
                            <li v-for="index in 7" :key="'phili'+index"
                                v-html="$t('clients.privacy_practices.phi.l' + index)"></li>
                        </ul>
                        <p v-html="$t('clients.privacy_practices.phi.txt8')"></p>
                        <p v-html="$t('clients.privacy_practices.phi.txt9')"></p>

                    </div>
                    <!--          Our Policy-->
                    <div class="row">
                        <h3 v-html="$t('clients.privacy_practices.our_policy.title')"></h3>
                        <p v-for="index in 8" :key="'our_policy'+index"
                           v-html="$t('clients.privacy_practices.our_policy.txt' + index)"></p>
                        <ul>
                            <li v-for="index in 6" :key="'other_disclosures'+index"
                                v-html="$t('clients.privacy_practices.our_policy.other_disclosures.li' + index)"></li>
                        </ul>
                        <p v-html="$t('clients.privacy_practices.our_policy.txt9')"></p>
                    </div>

                    <!--      Your Legal Rights-->
                    <div class="row">
                        <h3 v-html="$t('clients.privacy_practices.your_legal_rights.title')"></h3>
                        <p v-for="index in 8" :key="'your_legal_rights'+index"
                           v-html="$t('clients.privacy_practices.your_legal_rights.txt' + index)"></p>
                    </div>

                    <!--      FINAL -->
                    <div class="row" style="margin-top: 15px">
                        <p v-html="$t('clients.privacy_practices.our_contact.title')"></p><br>
                        <p v-html="$t('clients.privacy_practices.our_contact.title1')"></p><br>
                        <p v-html="$t('clients.privacy_practices.our_contact.title2')"></p>
                        <p v-for="index in 4" :key="'our_contact'+index"
                           v-html="$t('clients.privacy_practices.our_contact.txt' + index)"></p>
                        <p>
                            <strong>Office for Civil Rights</strong> <br>
                            <strong>U.S. Department of Health and Human Services</strong><br>
                            <strong>200 Independence Avenue, S.W. Room 509F, HHH Building Washington, D. C.
                                20201</strong><br>
                            <strong>OCR Hotlines-Voice: 1-800-368-1019</strong><br>
                        </p>
                        <p class="destacated" v-html="$t('clients.privacy_practices.our_contact.txt5')"></p>


                    </div>

                </div>
            </div>


        </b-modal>
    </div>

</template>

<script>

    import Navbar from './views/Navbar'
    import Footer from './views/Footer'
    // import store from './store/index'
    import axios from 'axios'
    import {Notice} from "@/main";

    export default {
        name: 'App',
        data() {
            return {
                animation1: null,
                sharedState: this.$store.state
            }
        },
        components: {
            Navbar,
            Footer
        },
        created: function () {
            this.addData();
        },
        methods: {
            addData() {
                axios.get('./assets/data/news/news.json')
                    .then((res) => {
                        let result = [];
                        res.data.map(n => {
                            const newsEs = new Notice(n['es'].title, n['es'].subTitle, n['es'].poster, n['es'].texts, n['es'].readMore, n['es'].collapsed);
                            const newsEn = new Notice(n['en'].title, n['en'].subTitle, n['en'].poster, n['en'].texts, n['en'].readMore, n['en'].collapsed);
                            result.push({es: newsEs, en: newsEn});
                        });

                        this.$store.commit('change', result);
                        // store.commit('loadNotys', res.data);
                    }).catch((err) => {
                    console.log(err);
                });


            },
        },
    }


</script>

<style lang="scss">
    @import "assets/scss/main";

    /*FIX SLIDE COMPONENT*/
    .navbar {
        padding: 0;
    }

    .navbar-expand-md .navbar-nav .nav-item {
        padding-left: 0;
    }

    .navbar-brand {
        /*padding: 0 !important;*/
    }

    .top-context {
        z-index: 15
    }

    .top-context, .bottom-context {
        height: 80px;
        background-color: #e0f2f1;
        padding: 10px;
        position: relative;
        z-index: 15;
    }

    .bottom-context {
        height: 150px;

    }

    .content-center {
        margin: -80px 0 -150px 0;
        padding: 80px 10px 150px 10px;
        height: 100%;

    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #616e7d;
        margin-top: 60px;

    }

    .modal-dialog {
        max-width: 80% !important;
    }

    .modal-title {
        width: 100%;
        text-align: center;
        text-transform: uppercase;
    }

    #modal-about-us-1 {
        .icon {
            text-align: center;

            img {
                width: 215px;
            }
        }

        .content {
            text-align: justify;
            padding: 0 10px;

            p {
                font-size: 1.5em;
                line-height: 1.5em;
            }

            ul {
                font-size: 1.5em;
                line-height: 1.5em;
                padding: 15px;

                li {
                    font-weight: 600;
                    list-style: circle;
                }
            }
        }
    }

    #modal-statement, #modal-notice-privacy {
        .clients-content {
            padding: 0 15px;
        }

        .icon {
            width: 100%;
            position: relative;
            height: 150px;

            img {
                width: 150px;
                margin: auto;
                left: 0;
                right: 0;
                position: absolute;
            }
        }

        p {
            font-size: 1.5em;
            font-weight: 500;
            text-align: justify;
            line-height: 1.6em;
            padding-bottom: 5px;
            font-family: 'Raleway', sans-serif;

            &.destacated {
                font-size: 1.7em;
                font-weight: 800;
            }
        }

        h3 {
            font-size: 1.8em;
            margin: 15px 0;
            width: 100%;
            text-align: center;
            color: #39403e;
        }

        ul {
            padding: 10px 30px;

            li {
                list-style: decimal;
                font-size: 1.5em;
                font-weight: 500;
                margin-bottom: 10px;
            }
        }
    }
</style>
